import { Text } from '@fluentui/react-components';
import cn from 'classnames';
import DOMPurify from 'dompurify';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NewsWidgetItem } from './News.interface';
import './NewsSingle.scss';

export interface NewsSingleProps {
  news: NewsWidgetItem;
  classNames?: string;
}

const MAX_LENGTH = 300;
const truncateText = (text: string) => {
  if (text.length <= MAX_LENGTH) return text;
  return text.slice(0, MAX_LENGTH) + '...';
};

export const NewsSingle: FC<NewsSingleProps> = ({ news, classNames }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  const description = news.description ?? '';
  const displayNewsDescription = isExpanded ? description : truncateText(description);
  const hasMore = description.length > MAX_LENGTH;

  return (
    <div className={cn('NewsSingle', classNames)}>
      <div className="newsContent">
        <Text className="newsTitle" as="h3" weight="bold">
          {news.title}
        </Text>
        <Text className="newsPublishedDate" size={200} color="subtle">
          {t('dashboard:news:published', { defaultValue: 'Veröffentlicht am {{date}}', date: news.publishDate ? new Date(news.publishDate).toLocaleDateString() : '', })}
        </Text>
        <div
          className="newsDescription"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(displayNewsDescription) }}
        />
        {hasMore && (
          <Text size={200} className="newsShowMore" onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? t('show_less', { defaultValue: 'Weniger anzeigen' }) : t('show_more', { defaultValue: 'Mehr anzeigen' })}
          </Text>
        )}
      </div>
    </div>
  );
};
